module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"contents":{"podcasts":{"meta_tags":{"description":"Bei CAPinside gibt’s was auf die Ohren! Spannendende Investmentstories von Meinungsführern und Experten aus der Branche.","title":"Podcasts"},"teaser":"Hören Sie rein in unsere Audiobeiträge, mit spannenden Gästen aus Finanzwelt und Fondsindustrie.","title":"Podcasts"}}}}}}')
  delete Component.options._Ctor
}
